import {useCallback, useEffect} from "react";

import {captureConnectionLost} from "@/src/modules/core/lib/glitchtip/device-capture";

import {useSetIsOnline} from "../store/is-online";

export default function useCheckConnection() {
  const setIsOnline = useSetIsOnline();

  const handler = useCallback(() => {
    const isOnline = navigator.onLine;

    if (!isOnline) {
      captureConnectionLost();
    }

    setIsOnline(isOnline);
  }, [setIsOnline]);

  useEffect(() => {
    window.addEventListener("online", handler);
    window.addEventListener("offline", handler);

    return () => {
      window.removeEventListener("online", handler);
      window.removeEventListener("offline", handler);
    };
  }, [handler]);
}
